module.exports = __webpack_public_path__ + "static/img/16.1592bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/16.png
// module id = P48a
// module chunks = 0